/*

using the state manager to call the final timer modal

maximumUserWaitTime => expected time for being timed out
threshHoldTime => how long to wait before call

Support function registerUserActivity

setupListeners
    - setup listeners for activity

registerUserActivity
    - checks if timers are setup properly
    - call logUserActivity

keepAlive entry point function
    - initiates logUserActivity
    - spawns webworker for timer
    - posts data to webworker
    - expect update in return from webworker
    - based on update makes the call

    - returns a Promise resolve when user is Idle
    - returns a Promise reject when user is active to silently call API

logUserActivity function
    - uses current time stamp of user and adds to local store
    - if there is any user activity shuffle the times - duuuhh!!

stopWorker function
    - removal of web-workers
    - call unregisterUserActivity

unregisterUserActivity function
    - called for cleanup of local store
    - called for cleanup of listeners

startAudio
    - Get the HTMLElement instance
    - Start the audio file
    - Set voulme of the audio file to Zero

stopAudio
    - Get the HTMLElement instance
    - Pause the audio file

*/
// threshhold flag
var threshHoldFlag = false;
// expire flag
var timeExpiredFlag = false;
// tslint:disable-next-line:no-any
var wkr;
var userTimeStampKey = 'ATTSales::userTimeStamp';
var oldUserTimeStampKey = 'ATTSales::oldUserTimeStamp';
var maximumUserWaitTimeKey = 'ATTSales::maximumUserWaitTime';
var threshHoldTimeKey = 'ATTSales::threshHoldTime';
function setupListeners() {
    // add listeners
    window.addEventListener('mousemove', registerUserActivity);
    window.addEventListener('mouseenter', registerUserActivity);
    window.addEventListener('mouseleave', registerUserActivity);
    window.addEventListener('resize', registerUserActivity);
    window.addEventListener('scroll', registerUserActivity);
    window.addEventListener('touchstart', registerUserActivity);
    window.addEventListener('touchend', registerUserActivity);
    // start the audio
    setTimeout(function () {
        if (isMobile()) {
            startAudio();
        }
    }, 1100);
}
function keepAlive(maximumUserWaitTime, threshHoldTime) {
    // Get the current 'global' time from an API using Promise
    return new Promise(function (resolve, reject) {
        // Before creating a web worker, check whether the user's browser supports it
        // and there is no worker created already
        if (typeof (Worker) !== 'undefined') {
            if (wkr) {
                console.log('There is already a worker started. no need to anything');
                reject(2);
            }
            else {
                var userTimeStampValue = localStorage.getItem(userTimeStampKey);
                // instantiate the web-worker
                wkr = new Worker('/buy/webWorkerRunTimer.js');
                /* Spawn web-worker */
                wkr.postMessage({ userTimeStampValue: userTimeStampValue, threshHoldTime: threshHoldTime, maximumUserWaitTime: maximumUserWaitTime });
                // tslint:disable-next-line:no-any
                wkr.onmessage = (function (event) {
                    threshHoldFlag = !!(event && event.data && event.data.threshHold);
                    timeExpiredFlag = !!(event && event.data && event.data.timeExpired);
                    var oldUserTimeStamp = localStorage.getItem(oldUserTimeStampKey);
                    var maxtimeAllowed = localStorage.getItem(maximumUserWaitTimeKey);
                    var threshHold = localStorage.getItem(threshHoldTimeKey);
                    var currentTime = new Date().getTime().toString();
                    if (threshHoldFlag && timeExpiredFlag && maxtimeAllowed &&
                        (Number(maxtimeAllowed) <= Number(currentTime)) &&
                        (!oldUserTimeStamp || (Number(oldUserTimeStamp) === 0))) {
                        // No activity found, reached the timelimit, expire the session
                        stopWorker();
                        resolve(3);
                    }
                    else if (threshHoldFlag && threshHold &&
                        (Number(threshHold) <= Number(currentTime))
                        && (!oldUserTimeStamp || (Number(oldUserTimeStamp) === 0))) {
                        // No activity found, not reached the timelimit, alert the user
                        stopWorker();
                        resolve(1);
                    }
                    else {
                        // user activity found, make a call to the API
                        stopWorker();
                        resolve(2);
                    }
                });
            }
        }
        else {
            console.warn('Sorry! No Web Worker support.');
            reject(1);
        }
    });
}
function logUserActivity() {
    // time stamp the user
    var oldUserTimeStamp = localStorage.getItem(userTimeStampKey) || 0;
    localStorage.setItem(oldUserTimeStampKey, oldUserTimeStamp.toString());
    // time stamp the user
    var userTimeStamp = new Date().getTime();
    localStorage.setItem(userTimeStampKey, userTimeStamp.toString());
}
function registerUserActivity() {
    var maximumUserWaitTime = Number(localStorage.getItem(maximumUserWaitTimeKey));
    var threshHoldTime = Number(localStorage.getItem(threshHoldTimeKey));
    // check timer setup
    if (((threshHoldTime > 0) && (threshHoldTime > maximumUserWaitTime))) {
        console.warn('The timings are not setup properly');
        unregisterUserActivity();
    }
    // call to update the user activity
    logUserActivity();
}
function stopWorker() {
    if (wkr) {
        wkr.terminate();
        // stop the audio
        if (isMobile()) {
            stopAudio();
        }
        // cleanup and unregister events
        unregisterUserActivity();
        wkr = null;
    }
}
function unregisterUserActivity() {
    // clean up of listeners added on window
    window.removeEventListener('mousemove', registerUserActivity);
    window.removeEventListener('mouseenter', registerUserActivity);
    window.removeEventListener('mouseleave', registerUserActivity);
    window.removeEventListener('resize', registerUserActivity);
    window.removeEventListener('scroll', registerUserActivity);
    window.removeEventListener('touchstart', registerUserActivity);
    window.removeEventListener('touchend', registerUserActivity);
}
// Audio file Management
function startAudio() {
    var myAudio = document.querySelector('#audio_player');
    if (myAudio) {
        myAudio.play();
        myAudio.volume = 0;
    }
}
function stopAudio() {
    var myAudio = document.querySelector('#audio');
    if (myAudio) {
        myAudio.pause();
    }
}
function isMobile() {
    return (window.innerWidth < 768);
}
export { keepAlive, setupListeners, registerUserActivity, stopWorker, unregisterUserActivity, userTimeStampKey, oldUserTimeStampKey, maximumUserWaitTimeKey, threshHoldTimeKey };
//# sourceMappingURL=keepAlive.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/services/keepAlive.js
// module id = 1733
// module chunks = 8